import React from 'react';
import CircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';

export type SpinnerProps = CircularProgressProps;

export const Spinner = (props: SpinnerProps): JSX.Element => {
  return <CircularProgress {...props} />;
};
